import { render, staticRenderFns } from "./DigitalClock.vue?vue&type=template&id=f59a4fd8&scoped=true&"
import script from "./DigitalClock.vue?vue&type=script&lang=js&"
export * from "./DigitalClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59a4fd8",
  null
  
)

export default component.exports